const initState = {
  ads: [],
  lastDocument: null,
  hasMoreDocument: true,
};

const getAdsReducers = (state = initState, action) => {
  switch (action.type) {
    case "GET_ADS":
      return {
        ...state,
        ads: action.payload.ads,
        lastDocument: action.payload.lastVisible,
        hasMoreDocument: action.payload.hasMoreDocument,
      };
    case "GET_ADS_LOAD_MORE":
      return {
        ...state,
        ads: [...state.ads, ...action.payload.ads],
        lastDocument: action.payload.lastVisible,
        hasMoreDocument: action.payload.hasMoreDocument,
      };
    default:
      return {
        ...state,
      };
  }
};
export default getAdsReducers;
